export const exportHeaders = [
    { 
        label: "Program", 
        key: "program" 
    },
    { 
        label: "Category", 
        key: "category" 
    },
    { 
        label: "Type", 
        key: "type" 
    },
    { 
        label: "Category Value", 
        key: "category_value" 
    },
    { 
        label: "Status", 
        key: "is_active" 
    }
   
]